<script setup lang="ts">
defineProps<{
  text: string;
}>();
</script>

<template>
  <span class="tooltip" :title="text">?</span>
</template>

<style scoped>
.tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #0f172a;
  font-size: 0.75rem;
  margin-left: 0.35rem;
}
</style>
